// extracted by mini-css-extract-plugin
module.exports = {"container":"e_eB","icon":"e_fB"};